var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-section',{staticClass:"home"},[_c('home-hero'),_c('v-divider'),_c('get-started')],1)}
var staticRenderFns = []

export { render, staticRenderFns }